import { extend } from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { updateOdataOptionsForFinalUrl } from '../util/update-final-url-property-for-filter';

export class GoalSchemaProcessor extends BaseSchemaProcessor {
  constructor(options) {
    super(options);
    this.goalsI18n = options.passedInI18n;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);
    const {
      IsViewThroughConversionEnabled,
      dynamic = {},
    } = this.Permissions;
    const {
      PartialConversions: IsPartialConversionsEnabled,
      ColumnConversion: IsColumnConversionEnabled,
    } = dynamic;
    const usePartialConversions = IsPartialConversionsEnabled && IsColumnConversionEnabled;

    updatedSchema.properties.IsMainConversionGoal = {
      filterable: true,
      name: 'IsMainConversionGoal',
      chooseType: 'radio-boolean',
      type: 'boolean',
      property: 'IsMainConversionGoal',
    };

    if (IsViewThroughConversionEnabled) {
      if (usePartialConversions) {
        updatedSchema.properties.ViewThroughConversionsCredit = {
          filterable: true,
          name: 'ViewThroughConversionsCredit',
          type: 'number',
          property: 'GoalPerformanceMetrics/ViewThroughConversionsCredit',
          required: true,
          alias: {
            propertyConversion: {
              sourcePropertyType: 'number',
              sourcePropertyName: 'ViewThroughConversions',
            },
          },
        };
      } else {
        updatedSchema.properties.ViewThroughConversions = {
          filterable: true,
          name: 'ViewThroughConversions',
          type: 'number',
          property: 'GoalPerformanceMetrics/ViewThroughConversions',
          required: true,
          alias: {
            propertyConversion: {
              sourcePropertyType: 'number',
              sourcePropertyName: 'ViewThroughConversionsCredit',
            },
          },
        };
      }
    }

    delete updatedSchema.properties.Labels;

    if (this.goalsI18n) {
      extend(updatedSchema.properties.Status, {
        localized: {
          "Enum.GoalStatus'Paused'": this.goalsI18n.getString('EntityStatus_Paused'),
        },
      });
    }

    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    updateOdataOptionsForFinalUrl(odataOptions);

    return odataOptions;
  }
}
